// extracted by mini-css-extract-plugin
module.exports = {"link":"FAQ_link__3GRnF","content":"FAQ_content__30a2f"};